export const about = {
  hero: {
    title: 'Where Science Meets Daily Life',
    subtitle: 'The Origin of ShanDouDou',
    description: 'In the fast-paced urban jungle, we often face a dilemma: we crave a healthy body yet compromise on convenience and taste; we desire traditional food therapy but dread the tedious boiling and bitter flavors. ShanDouDou was born to solve this modern "dietary paradox".',
  },
  origin: {
    title: 'Brand Origin',
    story: 'Our story began in a modest yet magical food laboratory. A group of meticulous researchers sought the perfect chemical reaction between ancient Eastern food wisdom and modern food science.',
  },
  philosophy: {
    title: 'Core Philosophy',
    subtitle: 'Eastern Wisdom in Data',
    points: [
      { title: 'Data-Driven R&D', description: 'Behind every product lies countless data tests and sensory refinements. We validate traditional wisdom through scientific methods.' },
      { title: 'Clean Label Promise', description: 'Rejecting excessive chemical additives. Nature is the best formulator; the lab\'s mission is to remove impurities and keep the essence.' },
      { title: 'Global Sourcing', description: 'We source from premium origins worldwide to find the purest green ingredients and control quality from the source.' },
      { title: 'Medicinal Food Homology', description: 'Wellness doesn\'t have to be a bitter medicine. It can be a delightful journey for your taste buds. Health can be sweet, too.' },
    ],
  },
  vision: {
    title: 'Brand Vision',
    subtitle: 'Redefining "Light Wellness"',
    text: 'ShanDouDou is not just a food brand, but a proposer of a new lifestyle. We are committed to breaking the heavy impression of traditional tonics and creating light wellness foods that truly understand young people. We hope that when you feel tired, what you pull from your pocket is not just a snack, but a scientifically balanced health plan; a burst of natural energy that instantly revitalizes your body.',
  },
  nameMeaning: {
    title: 'Brand Meaning',
    subtitle: 'Hold Health in Your Pocket, Go Now',
    chars: [
      { char: '膳', explain: 'Beautiful food, the gentlest nourishment for the body' },
      { char: '兜兜', explain: 'A warm container that condenses complex nutrition into a pocket-sized form, easy to carry along' },
    ],
    english: 'foodgogo',
    englishMeaning: 'A vibrant attitude. Health should not be a static wait, but a dynamic companion.',
  },
  timeline: {
    title: 'Brand Milestones',
    events: [
      { year: '2023', event: 'ShanDouDou Lab founded, core R&D team assembled' },
      { year: '2024', event: 'First functional gummies launched, well received by young consumers' },
      { year: '2024', event: 'Freeze-dried tonic series released, FD technology recognized by industry' },
      { year: '2025', event: 'Chinese herbal energy bars launched, completing three-product portfolio' },
      { year: '2026', event: 'Full brand upgrade, launching light wellness lifestyle proposal' },
    ],
  },
};